export const RESOLVED_PROMISE = Promise.resolve();

export const $tate = '$tate';

export const EMPTY_ARR: [] = [];
